import React, { useState } from 'react';
import { axiosImageAuthFetch } from '../../helpers/apiActions/authFetch';
import { API_BASE_URL } from '../../constants';
import { useParams } from 'react-router-dom';
import Loader from '../loader';
import styles from './docuForm.module.css';
import CustomAlert from '../customAlert';

export function AddDocumentationForm() {
    
    const {id} = useParams();
    const orderedProductId = id;
    const [name, setName] = useState('');
    const [certificates, setCertificates] = useState([]);
    const [schemas, setSchemas] = useState([]);
    const [comments, setComments] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertTitle, setAlertTitle] = useState('');
    const [alertButtonLabel, setAlertButtonLabel] = useState('');
    const [alertButtonClassName, setAlertButtonClassName] = useState('');
    const [year, setYear] = useState('');

    // Håndterer filendringer
    const handleFileChange = (event) => {
        const { name, files } = event.target;
        if (name === 'certificates') {
            setCertificates(Array.from(files));
        } else if (name === 'schemas') {
            setSchemas(Array.from(files));
        }
    };

    // Håndterer skjema-submission
    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);

        const data = {
            name,
            comments,
            ordered_product: orderedProductId,
            year
        };

        const formData = new FormData();
        formData.append('data', JSON.stringify(data));

        certificates.forEach((file) => {
            formData.append('files.certificates', file);
        });

        schemas.forEach((file) => {
            formData.append('files.skjemaer', file);
        });

        // Logger FormData-innholdet for debugging
        for (let pair of formData.entries()) {
            console.log(pair[0] + ', ' + pair[1]);
        }

        try {
            const response = await axiosImageAuthFetch(`${API_BASE_URL}/historical-documentations`, formData);
            console.log(response);

            setAlertTitle('Success');
            setAlertMessage('The documentation was submitted successfully.');
            setAlertButtonLabel('OK');
            setAlertButtonClassName('btn-success');
            setShowAlert(true);

            setIsLoading(false);
        } catch (error) {
            console.error('Error submitting form:', error);

            setAlertTitle('Error');
            setAlertMessage('There was an error submitting the documentation. Please try again.');
            setAlertButtonLabel('OK');
            setAlertButtonClassName('btn-danger');
            setShowAlert(true);

            setIsLoading(false);
        }
    };

    if(isLoading) {
        return(<Loader />)
    }

    const handleCloseAlert = () => {
        setShowAlert(false);
    };

    const redirectUser = () => {
        window.location.reload();
    };

    return (
        <div>
            <form className={styles.form} onSubmit={handleSubmit}>
                <div className={styles.line}>
                        Navn:
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Navn"
                            required
                            className={styles.input}
                        />
                </div>
                <div className={styles.line}>
                        År:
                        <input
                            type="text"
                            value={year}
                            onChange={(e) => setYear(e.target.value)}
                            placeholder="År"
                            required
                            className={styles.input}
                        />
                </div>
                <div className={styles.line}>
                        Sertifikater:
                        <input
                            type="file"
                            name="certificates"
                            multiple
                            onChange={handleFileChange}
                        />
                </div>
                <div className={styles.line}>
                        Skjemaer:
                        <input
                            type="file"
                            name="schemas"
                            multiple
                            onChange={handleFileChange}
                        />
                </div>
                <div className={styles.line}>
                        Kommentarer:
                        <textarea
                            value={comments}
                            onChange={(e) => setComments(e.target.value)}
                            placeholder="Kommentarer"
                            className={styles.area}
                        />
                </div>
                <button className={`${styles.button}`} type="submit">Submit</button>
            </form>
            <CustomAlert
                show={showAlert}
                handleClose={handleCloseAlert}
                message={alertMessage}
                buttonLabel={alertButtonLabel}
                buttonClassName={alertButtonClassName}
                redirectUser={redirectUser}
                modalTitle={alertTitle}
            />
        </div>
    );
}


export default AddDocumentationForm;